import {
  Toolbar,
  SaveButton,
  List,
  SimpleForm,
  DateInput,
  DateField,
  TextInput,
  Datagrid,
  Edit,
  Create,
  TextField,
  ReferenceField,
  ReferenceInput,
  NumberInput,
  NumberField,
  SelectInput,
  required,
  Show,
  SimpleShowLayout,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { ExtraPagination } from './utils'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export const CustomToolbar = (props) => (
  <Toolbar {...props} classes={useStyles()}>
    <SaveButton />
  </Toolbar>
)

export const CoproMondayList = (props) => (
  <List
    {...props}
    exporter={false}
    pagination={<ExtraPagination />}
    perPage={100}
  >
    <Datagrid>
      <TextField source="name" label="Nom" />
      <TextField source="code" label="Code" />
      <TextField source="nom" label="Nom" />
      <TextField source="cocher7" label="VIC" />
      <TextField source="statut" label="Type de contrat" />
      <TextField
        source="presta_sp_cifiques__chauffagiste_portes_1"
        label="Presta spécifiques"
      />
      <TextField source="resp" label="RESP" />
      <TextField source="ics" label="ICS" />
      <TextField source="reg9" label="REG" />
      <TextField source="texte" label="Digicode" />
      <TextField source="cocher2" label="Gardien" />
      <TextField source="texte7" label="Gardiens Nom" />
      <TextField source="email" label="Gardien Email" />
      <TextField source="phone" label="Gardien Téléphone" />
      <TextField source="text3" label="Président CS (nom)" />
      <TextField source="email5" label="Président CS (mail)" />
      <TextField source="phone2" label="Président CS (tel)" />
    </Datagrid>
  </List>
)
